<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterDates
        :fetchData="fetchAnnouncements" 
        :dateRange="true" 
        :label="$t('announcement.label.list.createdAt')" 
        startDateProp="startCreatedAt"
        endDateProp="endCreatedAt" 
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterDates 
        :fetchData="fetchAnnouncements" 
        :dateRange="true" 
        :label="$t('announcement.label.list.releaseDate')" 
        startDateProp="startReleaseDate" 
        endDateProp="endReleaseDate"   
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterSelect
          :fetchData="fetchAnnouncements"
          :label="$t('announcement.label.create.announcementType')"
          :items="announcementTypes"
          item-value="value"
          item-text="label"
          type="type"
        />
    </v-col>
  </v-row>
</template>

<script>

import { mapActions } from 'vuex'
import FilterDates from '@/components/filters/FilterDates'
import FilterSelect from '@/components/filters/FilterSelect'

export default {
  name: 'AdminAnnouncementListFilters',
  components: {
    FilterDates,
    FilterSelect
  },
  data() {
    return {
      announcementTypes: [
        {label: this.$t('announcement.label.create.announcementTypes.HOST'), value: 'HOST'},
        {label: this.$t('announcement.label.create.announcementTypes.ALL'), value: 'ALL'},
        {label: this.$t('announcement.label.create.announcementTypes.CUSTOMER'), value: 'CUSTOMER'},
      ],
    }
  },

  methods: {
    ...mapActions(['fetchAnnouncements']),
  },
}
</script>
